import { Flex, FlexProps } from '@radix-ui/themes'

export const ScreenWrapper = (props: FlexProps) => (
  <Flex direction="column" gap="2" flexGrow="0" flexShrink="1" {...props} width="100%" overflow="hidden" />
)
